<script setup>
import { onMounted, onUnmounted, ref, watch, defineProps } from "vue";
import { NPopconfirm, NIcon, useMessage, NProgress, useDialog } from "naive-ui";
import {
  getCheckSum,
  sendReport,
  isWireless,
  reportParams,
  mouseDevice,
} from "@/common";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { KEY_MAP } from "../baseData/system";
import { language } from "@/hooks/util/i18n";
const main = useStore();
const dialog = useDialog();
const {
  indexData,
  device,
  changeSetting,
  languageValue,
  currentMouse,
  mouseData,
} = storeToRefs(main);
const props = defineProps({
  currentIndex: Number,
});
watch(props, (newValue) => {
  current.value = newValue.currentIndex;
  console.log("props", newValue.currentIndex);
});
const message = useMessage();
const list = [
  {
    value: "运行状态",
    icon: require("@/images/left1.png"),
    activeIcon: require("@/images/left1-active.png"),
  },
  {
    value: "按键功能",
    icon: require("@/images/left2.png"),
    activeIcon: require("@/images/left2-active.png"),
  },
  {
    value: "DPI",
    icon: require("@/images/left3.png"),
    activeIcon: require("@/images/left3-active.png"),
  },
  {
    value: "回报率",
    icon: require("@/images/left4.png"),
    activeIcon: require("@/images/left4-active.png"),
  },
  {
    value: "宏定义",
    icon: require("@/images/left5.png"),
    activeIcon: require("@/images/left5-active.png"),
  },
  {
    value: "性能设置",
    icon: require("@/images/left6.png"),
    activeIcon: require("@/images/left6-active.png"),
  },
  {
    value: "固件",
    icon: require("@/images/left7.png"),
    activeIcon: require("@/images/left7-active.png"),
  },
];
const current = ref(0);
const isWorkMode = ref(true);
const emit = defineEmits(["emitIndex", "emitReset"]);
const handleClick = async (index) => {
  if (!isWorkMode.value) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: "设备处于升级模式，请进行固件升级",
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert("设备处于升级模式，请进行固件升级");
    return;
  }
  const devices = await navigator.hid.getDevices();
  // console.log("deviceLength", devices, devices.length);
  let count = 0;
  for (let i = 0; i < devices.length; i++) {
    if (Number(devices[i].vendorId) === 6421) {
      count++;
    }
  }
  if (!count) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["请使用2.4G模式或者有线模式连接设备"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["请连接设备"]);
    return;
  }
 
  if (!defaultValue.value) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content:
        language[languageValue.value]["请唤醒鼠标,且确保鼠标处于2.4G模式"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    
    return;
  }
  current.value = index;
  emit("emitIndex", index);
};

watch(mouseData, (newValue) => {
  if (newValue.length) {
    const index = Number(device.value.productId) === 1832 ? 28 : 16;
    if (newValue[index] === "01") {
      emit("emitIndex", 6);
      isWorkMode.value = false;
    } else {
      isWorkMode.value = true;
    }
  }
});

const reset = () => {
  const resetData =
    "00090082ff0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
  try {
    sendReport(resetData + getCheckSum(resetData));
    localStorage.removeItem(currentMouse.value + "Lock");
    message.success("操作成功");
    emit("emitReset", +new Date());
    main.clearPacket()
  } catch (err) {
    message.error("操作失败");
  }
};
const wakeType = ref("");
const scrollDirect = ref("");
onMounted(async () => {
  if (changeSetting.value) {
    const arr = changeSetting.value.split(" ");
    charge.value = parseInt(arr[7], 16);
  }
});
onUnmounted(() => {
  defaultValue.value = "";
});
const defaultValue = ref("");
watch(currentMouse, (newValue) => {
  if (newValue) {
    defaultValue.value = "";
  }
});
watch(indexData, (newValue) => {
  
  if (!newValue) {
    return;
  }

  if (newValue) {
    defaultValue.value = newValue;
    const arr = newValue.split(" ");
    // console.log("a", arr);
    const array = Object.keys(KEY_MAP);
    for (let i = 0; i < array.length; i++) {
      if (KEY_MAP[array[i]].toLowerCase() === arr[5].toLowerCase()) {
        // 设置滚动方向
        scrollDirect.value = Number(array[i][3]);
        break;
      }
    }
    console.log("唤醒数据", arr[39]);
    const num = mouseDevice() === "v2" ? 8 : 0;
    // 设置唤醒方式
    switch (arr[39 - num]) {
      case "00":
        wakeType.value = `移动唤醒 按键唤醒`;
        break;
      case "02":
        wakeType.value = `移动唤醒`;
        break;
      case "01":
        wakeType.value = `按键唤醒`;
        break;
      case "03":
        wakeType.value = ``;
        break;
    }
  }
});
const charge = ref(0);

watch(changeSetting, (newValue) => {
  
  if (!newValue) return;

  const arr = newValue.split(" ");
  charge.value = parseInt(arr[7], 16);
  // console.log(charge);
});
</script>

<template>
  <div style="width: 434px">
    <div v-for="(item, index) in list" :key="index" style="margin-top: 60px">
      <div>
        <img
          :src="index === current ? item.activeIcon : item.icon"
          alt=""
          style="width: 18px; height: 18px; vertical-align: middle"
        />
        <span
          class="word"
          :class="{ white: index === current }"
          @click="handleClick(index)"
          >{{ language[languageValue][item.value] }}</span
        >
      </div>
    </div>
    <div style="margin-top: 150px">
      <div v-if="current === 0">
        <div
          class="title"
          style="margin-bottom: 8px; position: relative; top: 30px"
        >
          {{ language[languageValue][wakeType] }}
        </div>
        <div
          class="title"
          style="margin-bottom: 8px; position: relative; top: 30px"
        >
          {{ language[languageValue]["滚动方向"] }}:{{
            language[languageValue][scrollDirect ? "反向" : "正向"]
          }}
        </div>
        <span class="title" style="margin-left: -310px">{{
          language[languageValue]["恢复出厂设置"]
        }}</span>
        <n-popconfirm
          @positive-click="reset"
          :positive-text="language[languageValue]['是']"
          :negative-text="language[languageValue]['否']"
          :show-icon="false"
        >
          <template #trigger>
            <img
              src="@/images/refresh.png"
              alt=""
              style="
                cursor: pointer;
                width: 16px;
                margin-left: 9px;
                margin-top: -4px;
                vertical-align: middle;
              "
            />
          </template>
          {{
            language[languageValue]["该操作会删除所有已保存的数据，是否继续？"]
          }}
        </n-popconfirm>
      </div>
      <div v-else-if="current !== 0 && isWireless()">
        <n-progress
          type="circle"
          :percentage="charge"
          :offset-degree="160"
          color="#2aa990"
          :stroke-width="15"
          rail-color="#2c3941"
          :circle-gap="0.5"
          style="width: 46px"
        >
          <span style="font-size: 11px; color: #b5d8f1; font-weight: normal"
            >{{ charge }}%</span
          >
        </n-progress>
      </div>
    </div>
  </div>
  <!-- <div style="color: #fff; margin-top: 150px; font-size: 14px">
    <span> 恢复出厂设置 </span>
  </div> -->
</template>

<style lang="less" scoped>
.white {
  color: #fff !important;
}
.word {
  font-family: PingFang;
  font-weight: 800;
  font-size: 14px;
  color: #637077;
  cursor: pointer;
  margin-left: 24px;
}
.title {
  font-family: PingFang;
  font-weight: 400;
  font-size: 14px;
  color: #637077;
}
</style>
